var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards"},[_c('div',{staticClass:"card one"},[_vm._v("1")]),_c('div',{staticClass:"card two"},[_vm._v("2")]),_c('div',{staticClass:"card three"},[_vm._v("3")]),_c('div',{staticClass:"card five"},[_vm._v("5")]),_c('div',{staticClass:"card eight"},[_vm._v("8")]),_c('p',[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }